import dynamic from 'next/dynamic';

import { lazyLoadImages } from 'src/utils/images';
import { ProductCarouselRecommendationsBlockProps } from '../../../components/blocks/ProductCarouselRecommendationsBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { Transformer } from '../../../types/Transformer';
import { ProductCarouselRecommendationsContentSection } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<ProductCarouselRecommendationsBlockProps> =
  dynamic<ProductCarouselRecommendationsBlockProps>(() =>
    import('../../../components/blocks/ProductCarouselRecommendationsBlock').then(
      (mod) => mod.ProductCarouselRecommendationsBlock,
    ),
  );

export const transformer: Transformer<
  ProductCarouselRecommendationsContentSection,
  ProductCarouselRecommendationsBlockProps
> = ({ placement_type, _metadata, tracking_title }, { pageMetadata, positionMetadata }) => ({
  uid: _metadata.uid,
  props: {
    currency: pageMetadata.currency,
    hasDisabledCookies: !pageMetadata.functionalCookiesConsented,
    placementType: placement_type,
    sessionId: pageMetadata.recommendationsSessionId,
    trackingTitle: tracking_title,
    lazyImages: lazyLoadImages(positionMetadata.position),
  },
});
